export const jidsConsumableSupplyNotification = [
  'California',
  'Colorado',
  'Connecticut',
  'Florida',
  'Georgia',
  'Indiana',
  'Kentucky',
  'Michigan',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'North Carolina',
  'Rhode Island',
  'South Dakota',
  'Texas',
  'Washington',
  'West Virginia',
];
